module.exports = __webpack_public_path__ + "static/media/logo.45211387.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo.png
// module id = 358
// module chunks = 0